function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  // Revoking synchronously can race the browser's async read of the blob
  // (seen on Safari/WebKit); defer to the next tick so the download starts first.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

export function exportToCsv(filename: string, headers: string[], rows: string[][]): void {
  const escape = (cell: string): string => {
    if (cell.includes(",") || cell.includes('"') || cell.includes("\n")) {
      return `"${cell.replace(/"/g, '""')}"`;
    }
    return cell;
  };

  const lines = [headers, ...rows].map((row) => row.map(escape).join(","));
  const csv = lines.join("\n");

  downloadBlob(filename, new Blob([csv], { type: "text/csv;charset=utf-8;" }));
}

export function exportToText(filename: string, text: string): void {
  downloadBlob(filename, new Blob([text], { type: "text/plain;charset=utf-8;" }));
}
